import { getHostName } from '@app/services/httpClient';

interface IProps {
  path: string;
  downloadName: string;
}

export const downloadExportedFile = ({ path, downloadName }: IProps) => {
  const link = document.createElement('a');

  link.download = downloadName;
  link.href = `${getHostName()}${path}`;
  link.click();
};
